import DateTimePickerActions from "./DateTimePickerActions";
import DateTimePickerMutations from "./DateTimePickerMutations";

const state = {
	dateTime: {
		startDate: "",
		startTime: "",
		endDate:   "",
		endTime:   "",
	}
};

const { actions } = DateTimePickerActions;

const { mutations } = DateTimePickerMutations;

const namespaced = true;

export default {
	state,
	actions,
	mutations,
	namespaced,
};